import {Control, Controller, FieldPath, FieldValues, PathValue, Path} from "react-hook-form";
import {Box, Checkbox, FormControl, FormControlLabel, FormControlProps, FormHelperText} from "@mui/material";

export interface Props<TFieldValues extends FieldValues = FieldValues> {
    name: FieldPath<TFieldValues>;
    control: Control<TFieldValues>;
    initialValue?: PathValue<TFieldValues, Path<TFieldValues>>;
    label: string;
    fontSize?: number;
    disabled?: boolean;
    inputProps?: Partial<FormControlProps>;
}

export const CheckboxInput = <TFieldValues extends FieldValues = FieldValues>(props: Props<TFieldValues>) => {
    const {name, control, initialValue, label, fontSize, disabled, inputProps} = props;

    return (
        <Controller
            name={name}
            control={control}
            defaultValue={initialValue}
            render={({field: {onChange, value}, fieldState: {error}}) => (
                <FormControl fullWidth error={!!error} data-test={name} {...inputProps}>
                    <FormControlLabel
                        label={<Box fontSize={fontSize ?? 14}>{label}</Box>}
                        control={
                            <Checkbox
                                sx={{
                                    paddingY: 0,
                                    paddingX: 0,
                                    marginLeft: "9px",
                                    marginRight: "6px",
                                }}
                                onChange={onChange}
                                checked={!!value}
                            />
                        }
                        disabled={disabled ?? false}
                    />
                    {error && <FormHelperText>{error.message}</FormHelperText>}
                </FormControl>
            )}
        />
    );
};
